import { render, staticRenderFns } from "./LgCreateFromPat.vue?vue&type=template&id=7c12a5bc"
import script from "./LgCreateFromPat.vue?vue&type=script&lang=js"
export * from "./LgCreateFromPat.vue?vue&type=script&lang=js"
import style0 from "./LgCreateFromPat.vue?vue&type=style&index=0&id=7c12a5bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports